import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import createAffiliatePortalInstance from "../../api/AffiliatePortalInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import type {
  AffiliatePortalViewData,
  AffiliatePortalViewQuery,
  ApiSuccessEnvelope,
} from "../../types/affiliates";

const fetchPortalView = async (
  query: AffiliatePortalViewQuery,
): Promise<AffiliatePortalViewData> => {
  const instance = createAffiliatePortalInstance();
  const params: Record<string, string> = {};
  if (query.start_date) params.start_date = query.start_date;
  if (query.end_date) params.end_date = query.end_date;
  const response = await instance.get<
    ApiSuccessEnvelope<AffiliatePortalViewData>
  >(API_ROUTES.AFFILIATE_PORTAL_VIEW, { params });
  return response.data.data;
};

export const usePortalView = (
  query: AffiliatePortalViewQuery,
  enabled = true,
): UseQueryResult<AffiliatePortalViewData, Error> =>
  useQuery<AffiliatePortalViewData, Error>({
    queryKey: ["affiliate-portal", "view", query.start_date, query.end_date],
    queryFn: () => fetchPortalView(query),
    enabled,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
    retry: false,
  });
